<template>
  <div>
    <thumbnails />
  </div>
</template>

<script>
import Thumbnails from "@/components/Thumbnails.vue";

export default {
  components: { thumbnails: Thumbnails }
};
</script>

